import { render, staticRenderFns } from "./HomeZeki.vue?vue&type=template&id=a7154e12&scoped=true&"
import script from "./HomeZeki.vue?vue&type=script&lang=js&"
export * from "./HomeZeki.vue?vue&type=script&lang=js&"
import style0 from "./HomeZeki.vue?vue&type=style&index=0&id=a7154e12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7154e12",
  null
  
)

export default component.exports